import useSyncRecentTradesWithDataApiServer from './useSyncRecentTradesWithDataApiServer';
import useSyncRecentTradesWithDlobServerWebsocket from './useSyncRecentTradesWithDlobServerWebsocket';

/**
 * SEE ui/src/hooks/velocityEvents/README.md for explanation of how these hooks link with rest of event syncing
 */

const useVelocityGlobalEventSubscribers = () => {
	useSyncRecentTradesWithDlobServerWebsocket();
	useSyncRecentTradesWithDataApiServer();
};

export default useVelocityGlobalEventSubscribers;
